<template>
  <Header />
  <main>
    <div class="layout-banner flex-y-center">
      <img :src='bannerImg' alt="" />
    </div>
    <RouterView v-slot="{ Component }">
      <component :is="hasData ? Component : 'Loading'"/>
    </RouterView>
  </main>
  <Footer />
</template>

<script>
import { computed } from "vue"
import { useDataStore, useScreenStore } from '@/store'

import Header from './Header.vue'
import Footer from './Footer.vue'

const bigBannerImg = require("@/assets/img/banner@2x.png")
const bannerImg = require("@/assets/img/banner@2x2.png")

export default {
  name: "layout",
  components: {
    Header,
    Footer,
    Loading: {
      setup() {
        return () => <div class="loading-box flex-center">加载中...</div>
      },
    },
  },
  setup() {
    const dataStore = useDataStore()
    const screenStore = useScreenStore()
    return {
      bannerImg: computed(() => {
        if (screenStore.screen === 2) {
          return bannerImg
        }
        return bigBannerImg
      }),
      hasData: computed(() => dataStore.data.length > 0)
    }
  }
}

</script>

<style lang="scss" scoped>
.layout-banner {
  img {
    width: 100%;
  }
}
main {
  padding-top: 70px;
}
.loading-box {
  height: 400px;
}
</style>